import { render, staticRenderFns } from "./TriggerMultipleAssessment.vue?vue&type=template&id=bc008154&scoped=true&"
import script from "./TriggerMultipleAssessment.vue?vue&type=script&lang=js&"
export * from "./TriggerMultipleAssessment.vue?vue&type=script&lang=js&"
import style0 from "./TriggerMultipleAssessment.vue?vue&type=style&index=0&id=bc008154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc008154",
  null
  
)

export default component.exports